import actions from './actions';
import getters from './getters';
import mutations from './mutations';


const state = {
  searchResults: {},
  isHideNavItems: false,
};

const store = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};

export default store;
